// Mantine
import { MRT_ColumnDef } from 'mantine-react-table';
import { Text, Flex, NumberFormatter } from '@mantine/core';

// Interfaces
import { Credit } from 'interfaces';

// Custom Components
import { ModalDateBadge } from 'components/common/ModalComponents';

import { DataBadge } from 'components/common/DataBadge';

import { formatDateTime, nowISO, parseDateTime } from 'utils/dateUtils';

export const CreditColumns = () => {
  const columns: MRT_ColumnDef<Credit>[] = [
    {
      accessorKey: 'providerID',
      header: 'Provider',
      accessorFn: (row) =>
        row.provider
          ? row.provider?.firstName + ' ' + row.provider?.lastName
          : '',
      Cell: ({ cell }) => {
        return <Text>{cell.getValue() as string}</Text>;
      },
    },
    {
      accessorKey: 'date',
      header: 'Payment Date',
      Cell: ({ cell }) => {
        const payDate = formatDateTime(cell.getValue() as string);

        return (
          <Flex justify={'center'} direction={'column'}>
            <Text>{payDate}</Text>
          </Flex>
        );
      },
      Edit: ({ cell }) => {
        return (
          <ModalDateBadge
            title="Payment Date"
            date={parseDateTime(cell.getValue() as string)}
            accessorKey="date"
          />
        );
      },
      mantineFilterDateInputProps: {
        valueFormat: 'YYYY-MM-DD',
        clearable: true,
        max: nowISO(),
      },
      filterVariant: 'date-range',
    },
    {
      accessorKey: 'amount',
      header: 'Amount',
      Cell: ({ cell }) => {
        return (
          <DataBadge>
            {
              <NumberFormatter
                prefix="$ "
                value={cell.getValue() as number}
                thousandSeparator
              />
            }
          </DataBadge>
        );
      },
    },
    {
      accessorKey: 'description',
      header: 'Description',
      Cell: ({ cell }) => (
        <Text>{(cell.getValue() as string | null) || '—'}</Text>
      ),
    },
  ];

  return columns;
};
